import React, { useState, useEffect, useContext, useCallback } from "react";
import { InputNumber } from 'primereact/inputnumber';
import TokenSelectButton from './TokenSelectButton';
import { formatCurrencyExtended, formatDecimals, getTokenLogo, formatBalanceWithIcon } from '../../utils';
import { Button } from 'primereact/button';
import BigNumber from "bignumber.js";

const TokenInput = React.memo(({ onSelectToken, token, balance, onAmountChange, amountIn, getTokenLogoUrl, readOnly=false }) => {

    const [amountInUSD, setAmountInUSD] = useState(0);

    const handlePercentageClick = (percentage) => {
        const calculatedAmount = new BigNumber(calculatePercentageAmount(percentage)).toFixed(0);
        onAmountChange(calculatedAmount);
    };

    const calculatePercentageAmount = useCallback((percentage) => {
        return balance ? (balance * percentage) / 100 : 0;
    }, [balance]);

    useEffect(() => {
        if (!amountIn || amountIn === 0) {
            setAmountInUSD(0);
        }
        if (token) {
            setAmountInUSD(amountIn * token?.price / (10 ** token?.decimals));
        }
    }, [amountIn]);

    return (

        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: '25px',
            padding: '10px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            width: '100%',
            marginBottom: '20px',
        }}>
            <TokenSelectButton onClick={() => onSelectToken('in')} token={token} getTokenLogoUrl={getTokenLogoUrl} />
            {(onAmountChange || readOnly) &&
                <>
                        <InputNumber
                            value={amountIn / 10 ** token?.decimals || ''}
                            onChange={(e) => onAmountChange(e.value * 10 ** token?.decimals)}
                            mode="decimal"
                            minFractionDigits={0}
                            maxFractionDigits={token?.decimals}
                            min={0}
                            style={{ width: '100%', marginTop: '20px' }}
                            inputStyle={{
                                background: 'transparent', border: 'none', outline: 'none', textAlign: 'right', fontSize: '24px', fontWeight: 'bold',
                                paddingBottom: '0px', paddingTop: '0px', color: '#EC599A',
                            }}
                            placeholder="0"
                            inputMode="decimal"
                            disabled={readOnly}
                        />

                  {  !readOnly &&    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <div style={{
                                display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'flex-end', gap: '3px', marginTop: '10px',
                            }}>
                                {/* Percentage Buttons */}
                                {[25, 50, 75, 100].map((percentage) => (
                                    <Button key={percentage} label={`${percentage}%`} onClick={() => handlePercentageClick(percentage)}
                                        style={{
                                            //background: 'rgba(175, 200, 255, 1)',
                                            // backgroundColor: '#E5F5FF',
                                            // color: 'black',
                                            backgroundColor: 'black',
                                            color: 'white',
                                            fontWeight: 'bold', cursor: 'pointer',
                                            borderRadius: '25px', fontSize: '10px',
                                            padding: '3px 6px 3px 6px',

                                            //outline: '1px solid white',
                                        }}
                                    />
                                ))}
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px', marginRight: '10px', fontSize: '12px' }}>
                                ~{formatCurrencyExtended(amountInUSD)}
                            </div>

                        </div>}
                   

                </>
            }
            
            <div style={{
                textAlign: 'right', color: 'black', marginLeft: '5px',
                //backgroundColor: 'rgba(0, 0, 0, 0.1)',
                paddingRight: '8px', paddingLeft: '8px', paddingTop: '8px', paddingBottom: '8px',
                borderRadius: '10px',
                alignContent: 'center', justifyContent: 'center', alignItems: 'center', fontSize: '14px',
                marginTop: onAmountChange ? '0px' : '20px',
            }}>
                Balance: {formatDecimals(balance, token?.decimals)} ({formatCurrencyExtended(balance * token?.price / (10 ** token?.decimals))})
            </div>

        </div>


    );
});

export default TokenInput;

// const TokenInput = React.memo(({ onSelectToken, token, balance, onAmountChange, amountIn, getTokenLogoUrl }) => {
//     return (
//         <div style={{
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             backgroundColor: 'white',
//             borderRadius: '25px',
//             padding: '20px',
//             boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//             width: '100%',
//             marginBottom: '20px'
//         }}>
//             <TokenSelectButton onClick={() => onSelectToken('in')} token={token} getTokenLogoUrl={getTokenLogoUrl} />
//             {onAmountChange && <InputNumber
//                 value={amountIn}
//                 onChange={(e) => onAmountChange(e.value)}
//                 mode="decimal"
//                 minFractionDigits={0}
//                 maxFractionDigits={token?.decimals}
//                 min={0}
//                 style={{ width: '100%', marginTop: '20px' }}
//                 inputStyle={{
//                     background: 'transparent', border: 'none', outline: 'none', textAlign: 'right', fontSize: '24px', fontWeight: 'bold',
//                     paddingBottom: '0px', paddingTop: '0px', color: '#EC599A',
//                 }}
//                 placeholder="0"
//             />}
//             <div style={{ marginTop: '10px', textAlign: 'center', color: '#555' }}>
//                 Balance: {formatDecimals(balance, token?.decimals)} ({formatCurrencyExtended(balance * token?.price / (10 ** token?.decimals))})
//             </div>
//         </div>
//     );
// });

// export default TokenInput;